/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onNewExport = /* GraphQL */ `subscription OnNewExport($username: String!) {
  onNewExport(username: $username) {
    username
    url
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnNewExportSubscriptionVariables,
  APITypes.OnNewExportSubscription
>;
